/**
 * @generated SignedSource<<4906cf45a743d80a0ea84f9ebfd8e6c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Locale = "EN" | "LT";
import { FragmentRefs } from "relay-runtime";
export type EditorJsField_data$data = {
  readonly languages: ReadonlyArray<{
    readonly locale: Locale;
    readonly " $fragmentSpreads": FragmentRefs<"EditorLanguageField_language" | "EditorToolbar_languages">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"EditorToolbar_data">;
  readonly " $fragmentType": "EditorJsField_data";
};
export type EditorJsField_data$key = {
  readonly " $data"?: EditorJsField_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorJsField_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditorJsField_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditorToolbar_data"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Language",
      "kind": "LinkedField",
      "name": "languages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locale",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EditorLanguageField_language"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EditorToolbar_languages"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "89ec08a06b1cadb60862b7fe3c25b06e";

export default node;
